/**
 * Generated by orval 🍺
 * Do not edit manually.
 * clarityrcm.api
 * OpenAPI spec version: 1.0
 */

/**
 * Why a channel cannot be used. Mirrors the checks the send itself applies. String-serialized.
 */
export type ResendChannelUnavailableReason =
  (typeof ResendChannelUnavailableReason)[keyof typeof ResendChannelUnavailableReason];

export const ResendChannelUnavailableReason = {
  MissingContact: "MissingContact",
  InvalidContact: "InvalidContact",
  UnderageGuarantor: "UnderageGuarantor",
  OptedOut: "OptedOut",
  Landline: "Landline",
  NoActiveGuarantor: "NoActiveGuarantor",
  NotTextable: "NotTextable",
} as const;
